<template>
  <div class="form-container">
    <div class="modal-card-title">카드 등록하기</div>
    <div class="input-label">카드 번호</div>
    <input class="input" type="text" v-model="value.card_num" placeholder="'-' 생략하고 입력" maxlength="16">
    <div class="err" v-if="err.card_num.err">{{ err.card_num.text }}</div>
    <div class="input-label">유효기간</div>
    <div class="flex">
      <input type="text" v-model="value.ex_month" placeholder="월" class="input input-date" maxlength="2" id="ex-month"  autocomplete="new-password" aria-hidden="true">
      <input type="text" v-model="value.ex_year" placeholder="년" class="input input-date" maxlength="2" id="ex-year" autocomplete="new-password" aria-hidden="true">
    </div>
    <div class="err" v-if="err.ex.err">{{ err.ex.text }}</div>

    <div class="input-label">카드 비밀번호 앞 2자리</div>
    <div class="flex-align">
      <input type="password" v-model="value.pw" class="input input-pw" maxlength="2" id="pw" autocomplete="new-password">
      <div class="h5">••</div>
    </div>
    <div class="err" v-if="err.pw.err">{{ err.pw.text }}</div>
    <div class="input-label">생년월일 6자리(개인) / 사업자번호 10자리(법인)</div>
    <input class="input" type="text" v-model="value.birth" maxlength="10">
    <div class="err" v-if="err.birth.err">{{ err.birth.text }}</div>

    <div class="btn-group-justify-end" style="margin-top:60px">
      <button class="button" @click="$emit('close')">취소</button>
      <button class="button is-primary" @click="$emit('done')">카드 등록하기</button>
    </div>

  </div>
</template>

<script>
  export default {
    name: "BillingForm",
    props: {
      service: {
        type: Object
      }
    },
    created() {

    },
    data() {
      return {
        value: {
          pg_type: 'payple',
          card_num: '',
          ex_year: '',
          ex_month: '',
          birth: ''
        },
        err: {
          card_num: {
            text: '카드 번호를 잘못 입력하셨습니다',
            err: false
          },
          ex: {
            text: '유효기간을 잘못 입력하셨습니다.',
            err: false
          },
          pw: {
            text: '비밀번호를 잘못 입력하셨습니다.',
            err: false
          },
          birth: {
            text: '생년월일/사업자번호를 잘못 입력하셨습니다.',
            err: false
          }
        }
      }
    },
    methods: {
      clickNpay() {
        this.toast('네이버페이 결제 방식은 아직 준비중입니다');
        // this.value.pg_type='npay';
      },
      validate() {
        let valid = true;
        Object.keys(this.value).forEach(key=>{
          if(this.value[key] === '') {
            valid = false;
          }
        });

        return valid;
      },
      saveRegBill() {

      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .button-grid
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-column-gap 20px

  .button-pay
    position relative
    padding 20px 24px
    border 1px solid #e3e3e3
    border-radius 4px
    box-shadow 0 2px 3px rgba(0, 0, 0, 0.07)
    height 96px
    display flex
    align-items center
    justify-content center

  .button-pay-selected
    border 2px solid $primary
    padding 16px 20px

  .checked-button
    width 20px
    height 20px
    border-radius 100%
    color white
    padding 2px
    background-color $primary
    position absolute
    top -10px
    right -10px

  .input-label
    font-size 14px
    font-weight 500
    margin 24px 0 6px 0

  .input-date
    width 80px
    margin-right 16px

  .input-pw
    width 80px
    margin-right 8px
    font-size 23px !important
    padding 6px 16px !important

  .err
    font-size 13px
    color $error
    margin-top 4px

</style>
